const FaviconPlugin = {
  install (Vue) {
    let originalHref = null;

    function getOriginalHref () {
      if (!originalHref) {
        const existing = document.querySelector("link[rel='icon']") ||
          document.querySelector("link[rel='shortcut icon']");
        originalHref = existing ? existing.href : '';
      }

      return originalHref;
    }

    function setFaviconHref (href) {
      document.querySelectorAll("link[rel='icon'], link[rel='shortcut icon']").forEach(node => {
        node.parentNode.removeChild(node);
      });

      const link = document.createElement('link');
      link.rel = 'icon';
      link.type = 'image/png';
      link.href = href;
      document.head.appendChild(link);
    }

    async function drawBadge (count) {
      count = parseInt(count, 10);
      const img = new Image();
      img.crossOrigin = 'anonymous';
      img.src = getOriginalHref();

      await new Promise((resolve, reject) => {
        img.onload = resolve;
        img.onerror = reject;
      });

      const size = 32;
      const canvas = document.createElement('canvas');
      canvas.width = size;
      canvas.height = size;
      const ctx = canvas.getContext('2d');
      ctx.drawImage(img, 0, 0, size, size);
      const text = count > 99 ? '99+' : String(count);
      ctx.font = 'bold 17px Arial, sans-serif';
      const textWidth = ctx.measureText(text).width;
      const padding = 3;
      const badgeW = textWidth + padding * 2;
      const badgeH = 18;
      const x = 0;
      const y = size - badgeH;
      ctx.fillStyle = '#d00';
      ctx.fillRect(x, y, badgeW, badgeH);
      ctx.fillStyle = '#fff';
      ctx.textAlign = 'center';
      ctx.textBaseline = 'middle';
      ctx.fillText(text, x + badgeW / 2, y + badgeH / 2 + 1);

      setFaviconHref(canvas.toDataURL('image/png'));
    }

    function reset () {
      if (originalHref) {
        setFaviconHref(originalHref);
      }
    }

    Vue.prototype.$favicon = {
      badge: drawBadge,
      reset
    };
  }
};

export default FaviconPlugin;



// WEBPACK FOOTER //
// ./src/plugins/favicon.js